import InputField from './InputField';

export default InputField;



// WEBPACK FOOTER //
// ./src/components/atoms/InputField/index.js